import { memo } from 'react';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { SortTH, TableHeaderCell as TH } from 'foundations-components/transitional/components/Table';
import I18n from 'I18n';
import TableAnalyticExplainer from './TableAnalyticExplainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getCellBlockSize, convertToTextAlign } from '../tableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const maybeBuildAnalyticExplainer = column => {
  const {
    field,
    label,
    dataset
  } = column;
  const aggregationType = dataset && dataset.getIn(['properties', field, 'propertyMeta', 'aggregationType']);
  return aggregationType ? /*#__PURE__*/_jsx(TableAnalyticExplainer, {
    label: label,
    aggregationType: aggregationType
  }) : null;
};
const defaultRenderHeaderCell = args => {
  const {
    column: {
      label,
      align,
      direction,
      onSort,
      field,
      tooltipI18nKey,
      showAsBarChart
    },
    isMobile
  } = args;
  const tooltip = tooltipI18nKey ? I18n.text(tooltipI18nKey) : null;
  const labelWithTooltip =
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsxs("span", {
    style: {
      fontSize: isMobile ? '10px' : 'inherit'
    },
    children: [label, ' ', tooltip ? /*#__PURE__*/_jsx(HelpIcon, {
      title: tooltip,
      alignWithText: true
    }) : maybeBuildAnalyticExplainer(args.column)]
  });
  if (onSort) {
    return /*#__PURE__*/_jsx(SortTH, {
      align: align,
      sort: direction || 'none',
      onSortChange: e => onSort(field, e),
      minInlineSize: "120px",
      blockSize: getCellBlockSize(isMobile),
      colSpan: showAsBarChart ? 2 : 1,
      children: labelWithTooltip
    });
  }
  return /*#__PURE__*/_jsx(TH, {
    minInlineSize: "120px",
    textAlign: convertToTextAlign(align),
    blockSize: getCellBlockSize(isMobile)
    // @ts-expect-error - colSpan is an attribute on HTML th, but not an explicit param of TH
    ,
    colSpan: showAsBarChart ? 2 : 1,
    children: /*#__PURE__*/_jsx(TFlex, {
      direction: "row",
      justifyContent: convertToTextAlign(align),
      children: labelWithTooltip
    })
  });
};
const TableHeaderCell = ({
  column,
  isMobile
}) => {
  const {
    renderHeaderCell
  } = column;
  const renderArgs = {
    column,
    isMobile
  };
  const defaultRender = () => defaultRenderHeaderCell(renderArgs);
  return renderHeaderCell ? renderHeaderCell(Object.assign({
    defaultRender
  }, renderArgs)) : defaultRender();
};
export default /*#__PURE__*/memo(TableHeaderCell);